export default __webpack_public_path__ + "static/media/LabSpecimen.5af8ee87.svg";